export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'thirdParty', label: '第三方', minWidth: '50'},
    {prop: 'channelName', label: '来源渠道', minWidth: '60'},
    {prop: 'resourcesCount', label: '资源数', minWidth: '50', sortable: true},
    {prop: 'repeatRate', label: '重复率', minWidth: '50', sortable: true, slotName: 'repeatRate'},
    {prop: 'deleteRate', label: '24小时删除率', minWidth: '70', sortable: true, slotName: 'deleteRate'},
    {prop: 'openRate', label: '开口率（第二次）', minWidth: '70', sortable: true, slotName: 'openRate'},
    {prop: 'lookRate', label: '看课率（直播）', minWidth: '70', sortable: true, slotName: 'lookRate'},
    {prop: 'dealCount', label: '成交资源数', minWidth: '60', sortable: true},
    {prop: 'monthConversionRate', label: '当月转化率', minWidth: '60', sortable: true, slotName: 'monthConversionRate'},
    {prop: 'lastMonthConversionRate', label: '上月转化率', minWidth: '60', sortable: true, slotName: 'lastMonthConversionRate'},
    {prop: 'accConversionRate', label: '累积转化率', minWidth: '60', sortable: true, slotName: 'accConversionRate'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
